<template>
  <div class="page-wrap">
    <el-menu
      default-active="af"
      :default-openeds="defaultOpends"
      class="el-menu-wrap"
      @select="handleMenuSelect"
    >
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-setting"></i>
          <span>参数配置</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="af" :class="{ menu: true }">af</el-menu-item>
          <el-menu-item index="gravitation">引力</el-menu-item>
          <el-menu-item index="meta">Meta</el-menu-item>
          <el-menu-item index="firebase">Firebase</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
    <div class="table-wrap">
      <af-table v-if="currentSelectIndex === 'af'"></af-table>
      <gravitation-table v-else-if="currentSelectIndex === 'gravitation'"></gravitation-table>
      <platform-para-table v-else :para-type="currentSelectIndex"></platform-para-table>
    </div>
  </div>
</template>

<script>
import afTable from "./afTable.vue";
import gravitationTable from "./gravitationTable.vue";
import platformParaTable from "./platformParaTable.vue";
export default {
  name: "paramsetting",
  mounted() {},
  components: {
    afTable,
    gravitationTable,
    platformParaTable,
  },
  data() {
    return {
      // 当前选中的菜单项
      currentSelectIndex: "af",
      defaultOpends: ["1"],
    };
  },
  computed: {},
  methods: {
    handleMenuSelect(index) {
      this.currentSelectIndex = index;
    },
  },
};
</script>
<style lang="less" scoped>
.page-wrap {
  width: 100%;
  height: calc(100% - 50px);
  display: flex;
  .el-menu-wrap {
    width: 300px;
    height: 100%;
    .el-icon-setting {
      color: #909399;
      font-size: 14px;
      font-weight: bold;
    }
    /deep/ .el-icon-arrow-down {
      color: #909399;
      font-size: 14px;
      font-weight: bold;
    }
  }
  .table-wrap {
    width: calc(100% - 300px);
    padding: 16px;
  }
}
</style>
